import { FC } from 'react';
import { SvgProps } from './domain';

const ComputerScreen: FC<SvgProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox='0 0 25 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1783_387)'>
        <path
          d='M15.1939 7.25109H3.97003C3.71045 7.25109 3.49988 6.8578 3.49988 6.37322C3.49988 5.88864 3.71045 5.49536 3.97003 5.49536H15.1939C15.4535 5.49536 15.6641 5.88864 15.6641 6.37322C15.6641 6.8578 15.4535 7.25109 15.1939 7.25109Z'
          fill='#03E4B3'
        />
        <path
          d='M15.1939 10.4115H3.97003C3.71045 10.4115 3.49988 10.0182 3.49988 9.53362C3.49988 9.04904 3.71045 8.65576 3.97003 8.65576H15.1939C15.4535 8.65576 15.6641 9.04904 15.6641 9.53362C15.6641 10.0182 15.4535 10.4115 15.1939 10.4115Z'
          fill='#03E4B3'
        />
        <path
          d='M15.1939 13.7474H3.97003C3.71045 13.7474 3.49988 13.3541 3.49988 12.8696C3.49988 12.385 3.71045 11.9917 3.97003 11.9917H15.1939C15.4535 11.9917 15.6641 12.385 15.6641 12.8696C15.6641 13.3541 15.4535 13.7474 15.1939 13.7474Z'
          fill='#03E4B3'
        />
        <path
          d='M15.3409 2.45802C16.0427 2.45802 16.6116 1.90777 16.6116 1.22901C16.6116 0.550245 16.0427 0 15.3409 0C14.6391 0 14.0702 0.550245 14.0702 1.22901C14.0702 1.90777 14.6391 2.45802 15.3409 2.45802Z'
          fill='#006FFF'
        />
        <path
          d='M12.9647 22.1748C12.3766 22.1748 11.8992 21.7797 11.8992 21.2917V18.5194C11.8992 18.0313 12.3766 17.6362 12.9647 17.6362C13.5529 17.6362 14.0303 18.0313 14.0303 18.5194V21.2917C14.0303 21.7797 13.5529 22.1748 12.9647 22.1748Z'
          fill='url(#paint0_linear_1783_387)'
        />
        <path
          d='M25 3.68695C25 3.61146 24.9873 3.53947 24.9691 3.46924C24.8693 1.75917 23.4044 0.398479 21.6127 0.398479H18.1927C17.6917 0.398479 17.2851 0.791761 17.2851 1.27634C17.2851 1.76092 17.6917 2.1542 18.1927 2.1542H21.6127C22.4677 2.1542 23.1648 2.82665 23.1648 3.65535V15.2203C23.1648 15.287 23.1593 15.3502 23.1502 15.4152C22.9923 16.1368 22.3279 16.6811 21.5346 16.6811H3.39638C2.53776 16.6811 1.83888 16.0051 1.83888 15.1729V3.60794C1.83888 2.781 2.53413 2.1068 3.39094 2.1068H10.4415C10.9425 2.1068 11.3491 1.71352 11.3491 1.22894C11.3491 0.744357 10.9425 0.351074 10.4415 0.351074H3.38912C1.53209 0.351074 0.0217833 1.81184 0.0217833 3.60794V3.72207C0.00726111 3.78352 0 3.84497 0 3.90993V15.129C0 16.9778 1.55569 18.4824 3.46718 18.4824H21.6036C23.27 18.4824 24.6551 17.3061 24.9256 15.7681C24.9728 15.5469 24.9982 15.3169 24.9982 15.0816V3.68695H25Z'
          fill='url(#paint1_linear_1783_387)'
        />
        <path
          d='M19.9445 9.35811H18.4614C17.6191 9.35811 16.9329 8.69445 16.9329 7.87979V6.44536C16.9329 5.6307 17.6191 4.96704 18.4614 4.96704H19.9445C20.7868 4.96704 21.4729 5.6307 21.4729 6.44536V7.87979C21.4729 8.69445 20.7868 9.35811 19.9445 9.35811ZM18.4614 6.02223C18.22 6.02223 18.0221 6.21185 18.0221 6.44712V7.88154C18.0221 8.11506 18.2181 8.30643 18.4614 8.30643H19.9445C20.1859 8.30643 20.3838 8.11681 20.3838 7.88154V6.44712C20.3838 6.21361 20.1877 6.02223 19.9445 6.02223H18.4614Z'
          fill='#006FFF'
        />
        <path
          d='M19.9445 14.4497H18.4614C17.6191 14.4497 16.9329 13.786 16.9329 12.9713V11.5369C16.9329 10.7223 17.6191 10.0586 18.4614 10.0586H19.9445C20.7868 10.0586 21.4729 10.7223 21.4729 11.5369V12.9713C21.4729 13.786 20.7868 14.4497 19.9445 14.4497ZM18.4614 11.1138C18.22 11.1138 18.0221 11.3034 18.0221 11.5387V12.9731C18.0221 13.2066 18.2181 13.398 18.4614 13.398H19.9445C20.1859 13.398 20.3838 13.2084 20.3838 12.9731V11.5387C20.3838 11.3052 20.1877 11.1138 19.9445 11.1138H18.4614Z'
          fill='#006FFF'
        />
        <path
          d='M18.151 22.9999H6.99065C6.48963 22.9999 6.08301 22.6066 6.08301 22.122C6.08301 21.6374 6.48963 21.2441 6.99065 21.2441H18.151C18.652 21.2441 19.0586 21.6374 19.0586 22.122C19.0586 22.6066 18.652 22.9999 18.151 22.9999Z'
          fill='url(#paint2_linear_1783_387)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1783_387'
          x1='14.3825'
          y1='18.5317'
          x2='11.6398'
          y2='21.3674'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.06' stopColor='#03E4B3' />
          <stop offset='1' stopColor='#007FF1' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1783_387'
          x1='0'
          y1='9.41588'
          x2='25'
          y2='9.41588'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.2' stopColor='#03E4B3' />
          <stop offset='0.69' stopColor='#007FF1' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1783_387'
          x1='6.08301'
          y1='22.122'
          x2='19.0586'
          y2='22.122'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.2' stopColor='#03E4B3' />
          <stop offset='1' stopColor='#007FF1' />
        </linearGradient>
        <clipPath id='clip0_1783_387'>
          <rect width='25' height='23' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ComputerScreen;
